import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const SingleValueWrapper = styled(InnerComponent).attrs({ Component: components.SingleValue })`
  && {
    margin: 0;
    height: 16px;
    color: ${colors.secondary20};
  }
`

const SingleValue = props => {
  return <SingleValueWrapper {...props} />
}

SingleValue.propTypes = {
  selectProps: PropTypes.object,
  data: PropTypes.object,
}

export default SingleValue
